import { render, staticRenderFns } from "./ProfilePictureSelector.vue?vue&type=template&id=8dc123a4"
import script from "./ProfilePictureSelector.vue?vue&type=script&lang=js"
export * from "./ProfilePictureSelector.vue?vue&type=script&lang=js"
import style0 from "./ProfilePictureSelector.vue?vue&type=style&index=0&id=8dc123a4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports